<template>

      <sc-dropdown-item
        class="card-dropdown-item"
        :disabled="!this.app.installed"
        @click="() => handleMonitoringIntegrationButton()"
      >
        <span> <sc-icon icon="heartbeat"></sc-icon> Monitorar </span>
      </sc-dropdown-item>


</template>

<script>
import { createNamespacedHelpers } from "vuex";
import {
  ScIcon,
  ScDropdownItem,
} from "@intelipost-js/secure-components";

const { mapActions } = createNamespacedHelpers("integrations/integrationsHome");

export default {
  name: "iplink-app-card-header-menu",

  props: {
    app: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...mapActions([
      "selectAppAction"
    ]),

    handleMonitoringIntegrationButton() {
      return ScToast.danger("A função Monitorar ainda não está habilitada. =(");
    },

  },

  components: {
    ScIcon,
    ScDropdownItem,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.page-integrations {
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/app-list/app-card/header-card/menu-card/monitor-button/MonitorButton.vue